import {TechnicalConclusionFormField} from "../types/technical-conclusion-types";
import {Validators} from "@angular/forms";

export const technicalConclusionFormFields: Array<TechnicalConclusionFormField> = [
  {
    fieldName: 'conclusionNumber',
    label: 'Номер технического заключения',
    type: 'text',
    validators: [Validators.required]
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    type: 'textarea'
  },
]
